import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as r } from "../SvgIcon.js";
const f = (l) => /* @__PURE__ */ o(r, { ...l, children: /* @__PURE__ */ o("path", { d: "M10 0c5.5249 0 10 4.47514 10 10 0 5.5249-4.4751 10-10 10-5.52486 0-10-4.4751-10-10C0 4.47514 4.47514 0 10 0ZM3.09392 11.3812l3.44752 3.4475 3.4475-3.4475-.97236-.9834-1.79007 1.79V7.23757H5.8453v4.95023l-1.779-1.79-.97238.9834ZM16.895 9.30386l-3.4585-3.44751-3.44756 3.44751.98346.98344 1.779-1.79007v4.95027h1.3812V8.49723l1.7901 1.79007.9723-.98344Z" }) });
export {
  f as Offline
};
//# sourceMappingURL=Offline.js.map
